<template>
    <div class="form">
        <el-form style="margin:20px;min-width:600px;" label-width="130px">
            <el-form-item class='edit-form' label="销售下单号">
                <span>{{Form.OrderCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="销售下单状态">
                <span>{{Form.OrderStatusName}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="代理商">
                <span>{{Form.AgentCode}} {{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="销售下单时间">
                <span>{{Form.OrderTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="销售下单人">
                <span>{{Form.SaleEmployeeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="商品" v-show="Form.ProductList!=''">
                <el-table :data="Form.ProductList" border style="width: 80%;  margin-left: 25px;">
                    <el-table-column prop="ProductName" label="商品名称">
                    </el-table-column>
                    <el-table-column prop="ProNum" label="商品数量">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label=" " v-show="true">
                <span style="font-size:16px;font-weight:bold;">销售总价:</span>
                <span style="font-size:16px;font-weight:bold;">{{Form.Total}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="赠品" v-show="Form.GiftList!=''" style="width:900px">
                <el-table :data="Form.GiftList" border style="width: 40%;  margin-left: 25px;">
                    <el-table-column prop="ProductName" label="名称">
                    </el-table-column>
                    <el-table-column prop="ProNum" label="订单数">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="凭证" v-show="Form.IsShowPrice">
                <div class="show-img-ctn uclear">
                    <template v-for="(item,index) in Form.VoucherPic">
                        <div class="show-img-cell" @click="LookPicture(item.Url)">
                            <img :alt="item.Name" :src="item.Url" />
                        </div>
                    </template>
                </div>
            </el-form-item>
            <el-dialog v-model="PictureVisible" size="tiny">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
            <el-form-item class='edit-form w100' label="收货地址">
                <span>{{Form.AgentConsignee}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="收货人及联系方式">
                <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="寄送方式">
                <span>{{Form.SendModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="支付方式">
                <span>{{Form.PayModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="销售下单备注">
                <span v-if="Form.OrderRemark!=undefined&&Form.OrderRemark!=''">{{Form.OrderRemark}}</span>
                <span v-else>--</span>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import NProgress from 'nprogress';
import { GetAuditOrderById } from '@api/orderApi.js';
import { util, lg } from 'utils';

module.exports = {
    data() {
        return {
            Form: {},
            dialogImageUrl: "",
            PictureVisible: false
        }
    },
    methods: {
        LookPicture(Url) {
            this.dialogImageUrl = Url;
            this.PictureVisible = true;
        }
    },
    created: function () {
        if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                Id: this.$route.query.Id
            };
            GetAuditOrderById(para).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    let Data = res.data.Data;
                    this.Form = [];
                    this.Form = Data;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
span {
    margin-left: 25px;
}
</style>


// WEBPACK FOOTER //
// AuditViewOrder.vue?4466014e